<template>
  <div class="login-page">
    <van-nav-bar
      title="登录"
      left-arrow
      @click-left="goHome"
      fixed
    />

    <div class="content">
      <div class="form-container">
        <h2 class="title">欢迎登录</h2>

        <van-field
          v-model="userName"
          label="用户名"
          placeholder="请输入用户名"
          clearable
        />

        <van-field
          v-model="passWord"
          type="password"
          label="密码"
          placeholder="请输入密码"
          clearable
        />

        <van-button
          type="primary"
          block
          round
          class="submit-btn"
          @click="handleLogin"
        >
          登录
        </van-button>

        <van-button
          type="info"
          block
          round
          class="register-btn"
          @click="goToRegister"
        >
          用户注册
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { userLogin } from '../utils/api';

export default {
  name: 'Login',
  data() {
    return {
      userName: '',
      passWord: ''
    };
  },
  mounted() {
    if (this.$route.query.userName) {
      this.userName = this.$route.query.userName;
    }
    if (this.$route.query.passWord) {
      this.passWord = this.$route.query.passWord;
    }
  },
  methods: {
    async handleLogin() {
      if (!this.userName.trim()) {
        this.$toast('请输入用户名');
        return;
      }
      if (!this.passWord) {
        this.$toast('请输入密码');
        return;
      }

      try {
        const res = await userLogin({
          userName: this.userName.trim(),
          passWord: this.passWord
        });

        if (res && res.code === 200) {
          const userInfo = {
            type: 'object',
            data: res.data
          };
          localStorage.setItem('userinfo', JSON.stringify(userInfo));
          this.$toast.success('登录成功');
          
          setTimeout(() => {
            this.$router.push('/');
          }, 500);
        }
      } catch (error) {
        console.error('Login error:', error);
        if (error.response && error.response.data && error.response.data.msg) {
          this.$toast(error.response.data.msg);
        } else {
          this.$toast('登录失败');
        }
      }
    },
    goToRegister() {
      this.$router.push('/register');
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
  padding-bottom: 50px;
}

.content {
  padding: 40px 16px;
}

.form-container {
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 32px;
}

.submit-btn {
  margin-top: 32px;
  height: 48px;
  font-size: 16px;
}

.register-btn {
  margin-top: 16px;
  height: 48px;
  font-size: 16px;
}
</style>
